import { useEffect, useState } from "react";

import { createScript } from "./browser";

let initialised = false;

export const useGoogleMaps = () => {
  const [loading, setLoading] = useState(true);
  const googleMapsApiKey = globalThis.settings.GOOGLE_MAPS_API_KEY;

  useEffect(() => {
    if (googleMapsApiKey && !initialised) {
      const src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&libraries=places&callback=Function.prototype`;
      createScript({
        src,
        onLoad: () => {
          initialised = true;
          setLoading(false);
        },
        async: true,
      });
    } else {
      setLoading(false);
    }
  }, [googleMapsApiKey]);

  return loading;
};
